<template>
	<div class="view-home" @click="user_menu_visible = false">
		
		<div class="pane left">
			<div class="scroll-wrap">
				<div class="scroll" v-bar>
					<div class="scroll-content">
				
						<div class="logo">
							<img src="../assets/img/logo.png" alt="CDC Habitat">
							<p class="sublogo">
								Portail des études
								<a
									class="adequation"
									href="https://www.adequation.fr/"
									target="_blank"
									v-html="require('../assets/img/logo-adequation.svg')"
								></a>
							</p>
						</div>
						
						<div class="pane-content">

							<p class="main-title clickable" @click="launch_search">
								<span class="main-icon"><icon file="search" :size="32" /></span>
								<span class="text">Trouver des études</span>
							</p>

							<div class="boxes">
								<div class="row">
									<div class="col sixty">
										<div class="box">
											<p class="box-title">Géographie</p>
											<div class="box-content">
												<div class="map-france">
													<div class="map-france-bg" v-html="require('../assets/img/france-region.svg')"></div>
													<div class="map-france-counts">
														<span v-for="region in facets.regions" :key="region.key" class="count" :class="'region-' + region.key">{{ region.doc_count }}</span>
													</div>
													<div class="map-france-hover" v-html="require('../assets/img/france-region.svg')"></div>
												</div>
											</div>
										</div>
									</div>
									<div class="col fourty">
										<div class="box">
											<p class="box-title">Segments de marché</p>
											<div class="box-content">
												<div class="segments">
													<div v-for="segment in facets.segments" :key="segment.key" class="segment-item" :class="segment.slug" @click="select_segment(segment)">
														<span class="segment-item-initals">{{ segment.initials }}</span>
														<span class="segment-item-name">{{ segment.key }}</span>
														<span class="segment-item-count">{{ segment.doc_count }}</span>
														<!-- <icon file="arrow-right" :size="24" /> -->
													</div>
												</div>
											</div>
										</div>
										<!-- <div class="box">
											<p class="box-title">Options</p>
											<div class="box-content">
												 <div class="segments">
													<input type="checkbox" id="checkbox" v-model="checked">
													<label for="checkbox">Relance 2020</label>
												</div>
											</div>
										</div> -->
									</div>
								</div>
							</div>
								
						</div>
			

					</div>
				</div>
			</div>
		</div>

		<div class="pane right">
			<div class="scroll-wrap">
				<div class="scroll" v-bar>
					<div class="scroll-content">
						<div class="menu">
							<a class="menu-item" @click="select_synthesis()"><icon file="pie-chart" :size="24" /> Synthèses & données</a>
							<!-- <span class="menu-item"><icon file="bell" :size="24" /> Notifications <span class="nb">14</span></span> -->
						</div>
						<div class="user">
							<div class="user-name" @click.stop="user_menu_visible = !user_menu_visible">
								<span class="initale">{{ user_initials }}</span>
								<span class="name">{{ user_name }}</span>
							</div>
							<div v-show="user_menu_visible" class="user-menu">
								<div class="action" @click="logout()">Déconnexion</div>
							</div>
						</div>
						<div class="pane-content">
							<p class="main-title">
								<span class="main-icon"><icon file="user" :size="32" /></span>
								<span class="text">Votre compte personnel</span>
							</p>

							<div class="box box-projects">
								<p class="box-title">Les dernières études...</p>
								<div class="box-content">
									<row-result v-for="project in account_projects" :key="project.id" :project="project" @click.native="select_project(project)" />
								</div>
							</div>

						</div>

					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { mapGetters } from "vuex"
import RowResult from "@/components/search/row-result"
import jquery from "jquery";
const $ = jquery;

export default {
	name: "view-home",
	data: function() {
		return {
			user_menu_visible: false,
			regions: {},
			checked : false
		}
	},
	computed: {
		// mix the getters into computed with object spread operator
		...mapGetters(["mode", "active_project", "query", "user_profile", "user_name", "user_initials", "facets", "projects"]),
		query_string: {
			get() {
				return this.query
			},
			set(newValue) {
				return this.$store.dispatch("set_query", { query: newValue })
			},
		},
		account_projects() {
			 //JNA : Sort projects by date
			var projects =this.projects;
			projects.forEach(function(project){
				project.lastStudyDate = project.publication_dates[project.publication_dates.length-1];
			});
			projects = _.orderBy(projects,['lastStudyDate'],['desc']);
			return _.slice(projects, 0, 10)
		},
		admin(){
			var admin = false;
			admin = (this.user_profile != null &&  this.user_profile.acces != null) ?  this.user_profile.acces.some(acces => acces.droit.code == "admin") : false;
			return admin;
		}
	},
	methods: {
		launch_search() {
			this.$gtm.trackEvent({
				category: 'Home',
				action: 'Click',
				label: 'Trouver des études'
			});

			this.$router.push({ name: 'search' });
		},
		select_project: function(project) {
			this.$gtm.trackEvent({
				category: 'Home',
				action: 'Click',
				label: 'Les dernières études...',
				value: project.name
			});

			this.$router.push({ name: 'search' })
		},
		select_segment: function(segment) {
			let self = this

			this.$gtm.trackEvent({
				category: 'Home',
				action: 'Click',
				label: 'Segments de marché',
				value: segment.key
			});

			this.$store.dispatch('set_filter', { segment: segment.key })
			//add filter on checkbox "relance"
			if(this.checked){
				console.log('jna checked : ',this.checked);
				this.$store.dispatch('set_filter', { relance: this.checked })
			}
			this.$store.dispatch('load_projects')
			this.$router.push({ name: 'search' })
		},
		select_synthesis: function() {
			this.$router.push({ name: 'synthesis'});
		},
		logout: function() {
			this.$gtm.trackEvent({
				category: 'Compte utilisateur',
				action: 'Logout'
			});

			this.$store.dispatch("auth_logout")
		},
		create_region_mapping() {
			// get the list of region from facets.regions
			this.regions = _.keyBy(this.facets.regions, 'key');
		}
	},

	mounted() {
		let self = this;
		this.create_region_mapping();

		$('#app .view-home .map-france-hover svg path').on('click', function(e) {
			if (this.id && this.id.substr(0, 4) == 'reg-') {
				let reg_id = parseInt(this.id.substr(4));
				if (reg_id) {
					self.$gtm.trackEvent({
						category: 'Home',
						action: 'Click',
						label: 'Region',
						value: reg_id
					});

					self.$store.dispatch('set_filter', { region: reg_id }) // self.regions[reg_id]
					self.$router.push({ name: 'search' })
					self.$store.dispatch("load_projects")
				}
			}
		})
	},
	components: { RowResult }
}
</script>

<style lang="stylus">
@import '../assets/css/app'


.view-home
	height 100%
	.pane
		float left
		height 100%
		width 50%
		padding 0 24px
		&.left
			width 60%
		&.right
			width 40%
			border-left 2px solid #eee
			background-color #f5f5f5


.logo
	position absolute
	left 0
	top 24px
	font-weight 500
	font-size 1.4rem
	line-height 16px
	font-weight 400
	color #3e5d58
	img
		display block
		height 54px
		width auto
	.sublogo
		position absolute
		left 0
		bottom -24px
		white-space nowrap
		.adequation
			bottom -5px
			display inline-block
			height 20px
			width 100px
			svg
				display block
				height 100%
				width auto

.pane-content
	margin-top 120px
	.clickable
		cursor pointer
	.main-title
		margin 0 0 40px 0
		font-size 2.4rem
		font-weight 500
		text-transform uppercase
		text-align center
		.main-icon
			display block
			width 48px
			height 48px
			padding 7px 8px
			margin 0 auto
			background-color #333
			border-radius 100%
			color #fff
			text-align center
			.icon
				display block
		.text
			display block
			margin 12px 0 0 0



.box
	border 2px solid #eee
	background-color #fff
	min-height: 500px;
	&.box-projects
		margin-bottom 24px
		.box-content
			padding-bottom 0
			.row-result:first-child
				border-top 1px solid #eee
	.box-title
		padding 24px
		font-size 2rem
		line-height 24px
	.box-content
		padding 0 0 24px 0
		overflow hidden
			

.map-france
	width 400px
	height 400px
	// margin-left 24px
	margin 0 auto
	.map-france-bg, .map-france-hover
		position absolute
		left 0
		top 0
		width 400px
		height 400px
		svg
			transform scale(0.65)
			transform-origin top left
			color #f5f5f5
			stroke #bbb
			stroke-width 1px
	.map-france-hover
		svg
			stroke transparent
			color transparent
			path
				transition 0.05s 
				cursor pointer
				&:hover
					stroke red
					fill alpha(red, 10%)
	.map-france-counts
		position absolute
		left 0
		top 0
		width 400px
		height 400px
		// background-color alpha(red, 50%)
		.count
			display none
			position absolute
			left 0
			top 0
			width 32px
			height 32px
			border-radius 100%
			background-color red
			color #fff
			line-height (@height - 2px)
			text-align center
			font-weight 500
			font-size 1.1rem
			border 1px solid #f5f5f5
			box-shadow 0 0 0 1px red
			&.region-11
				display block
				transform translate(182px, 85px)
			&.region-93
				display block
				transform translate(280px, 275px)
			&.region-84
				display block
				transform translate(240px, 215px)
			&.region-76
				display block
				transform translate(170px, 280px)
			&.region-75
				display block
				transform translate(120px, 220px)
			&.region-32
				display block
				transform translate(190px, 35px)
			&.region-44
				display block
				transform translate(260px, 85px)
			&.region-52
				display block
				transform translate(90px, 134px)
			&.region-24
				display block
				transform translate(160px, 135px)
			&.region-53
				display block
				transform translate(30px, 107px)
			&.region-28
				display block
				transform translate(120px, 75px)
			&.region-27
				display block
				transform translate(240px, 148px)
			&.region-94
				display block
				transform translate(360px, 335px)

.segments
	font-size 1.4rem
	.segment-item
		display block
		padding 8px 0 8px 24px
		line-height 24px
		cursor pointer
		white-space nowrap
		&.projet_lli
			.segment-item-initals
				background-color orange
		&.autre
			.segment-item-initals
				background-color darken(#4fa16e, 10%)
		&.expertise_immo
			.segment-item-initals
				background-color #607D8B
		&.projet_psla
			.segment-item-initals
				background-color darken(#bdcf75, 10%)
		&.accession_locatif_libre
			.segment-item-initals
				background-color blue
		&.etudes_territoriales
			.segment-item-initals
				background-color #2f4b7c
		&.projet_senior
			.segment-item-initals
				background-color darken(#f19452, 25%)
		&.locatif_social
			.segment-item-initals
				background-color purple
		&.projet_etudiant
			.segment-item-initals
				background-color darken(#d43d51, 10%)
		&.relance_2020
			.segment-item-initals
				background-color darken(#d43d51, 30%)
		&.action_coeur_ville
			.segment-item-initals
				background-color #ff8a80
		&.libre_abordable_contractualise
			.segment-item-initals
				background-color #536dfe
		&.accession
			.segment-item-initals
				background-color darken(green, 30%)
		&.bail_reel_solidaire
			.segment-item-initals
				background-color #64d8cb
		&.coliving
			.segment-item-initals
				background-color #ff4081
		&.copropriete_degradee
			.segment-item-initals
				background-color darken(blue, 10%)
		
		
		&:hover
			background-color #eee
			background-color lighten(red, 95%)
			.segment-item-name
				color red
			.segment-item-count
				background-color red
				color #fff
		.segment-item-initals
			float left
			padding 0 8px
			margin 0 8px 0 0
			background-color black
			border-radius radius
			// background-color #999
			font-size 1.2rem
			color #fff
		.segment-item-name
			font-weight 500
		.segment-item-count
			padding 2px 8px
			margin 0 0 0 8px
			background-color #ddd
			border-radius radius
			font-size 1.3rem
			font-weight 500


.menu
	position absolute
	left 0
	top 24px
	line-height 24px
	white-space nowrap
	.menu-item
		display inline-block
		padding 0 20px 0 0
		margin 0 16px 0 0
		font-weight 500
		cursor pointer
		&:hover
			color red
		&:last-child
			&:after
				display none
				padding-right 0
				margin-right 0
		&:after
			content ''
			position absolute
			right 0
			top 25%
			height 50%
			border-right 2px solid #333
		.icon
			float left
			margin 0 8px 0 0
		.nb
			position absolute
			left 12px
			top -8px
			background-color red
			border-radius 100%
			font-size 1.1rem
			width 20px
			height 20px
			box-shadow 0 0 0 2px #f5f5f5
			color #fff
			font-weight 500
			line-height @height
			text-align center

.user
	position absolute
	right 20px
	top (24px - 4px)
	white-space nowrap

	.user-name
		line-height 32px
		cursor pointer
		color #999
		&:hover 
			color #666
		.initale
			float left
			width 32px
			height 32px
			margin 0 8px 0 0
			border-radius 100%
			background-color red
			color #fff
			font-weight 500
			text-align center
	.user-menu
		position absolute
		right 0
		min-width 150px
		top 40px
		background #eee
		padding 8px 0
		border-radius radius
		&:before
			content ''
			position absolute
			left 50%
			top -8px
			margin-left -8px
			width 0
			height 0
			border-style solid
			border-width 0 8px 8px 8px
			border-color transparent transparent #eee transparent
		.action
			line-height 32px
			padding 0 16px
			cursor pointer
			text-align left
			&:hover
				background-color red
				color #fff

</style>
